import { RootState } from '..';
import { ICreateNotificationError } from './types';

export const errorsSelector = (
  state: RootState,
): ICreateNotificationError | undefined => state.notification.errors;
